import { AbstractFreewheelClass } from 'tag/ts/tag/ads/freewheel/abstract/AbstractFreewheelClass';
export class AbstractFreewheelRequestFactory extends AbstractFreewheelClass {
    constructor(argument) {
        super(argument);
    }
}
